import Reveal from "./Reveal";
import CountUp from "./CountUp";

const STATS = [
  { value: "278", label: "Happy returning customers", note: "loyale B2B partners" },
  { value: "±1.250", label: "Clean cars / maand", note: "voertuigen onderhouden" },
  { value: "4", label: "FTE washers", note: "vaste experten in team" },
  { value: "+500", label: "Flexi/student washers", note: "in samenwerking met Werkr" },
];

export default function Stats() {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-cgdark text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-20" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
            <div className="max-w-xl">
              <p className="eyebrow mb-5" data-testid="stats-eyebrow">Onze impact</p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">
                Cijfers die <br />
                <span className="text-cgprimary">vertrouwen wekken.</span>
              </h2>
            </div>
            <p className="text-white/60 max-w-sm text-base leading-relaxed">
              Sinds onze oprichting werken we voor honderden Belgische bedrijven,
              van KMO&apos;s tot logistieke spelers met grote vloten.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {STATS.map((s, i) => (
            <Reveal
              key={s.value}
              delay={i * 80}
              className="bg-cgdark p-8 md:p-10 lg:p-12 group"
              data-testid={`stat-card-${i}`}
            >
              <div className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-cgprimary leading-none mb-6 transition-transform duration-500 group-hover:-translate-y-1">
                <CountUp value={s.value} />
              </div>
              <div className="font-semibold text-base md:text-lg text-white mb-2">{s.label}</div>
              <div className="text-white/50 text-sm">{s.note}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
